import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmbedsRPC } from "./getEmbedsRPC";

export class GetEmbedsRPCClientImpl extends GetEmbedsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmbedsRPC.Request): Promise<LeoRPCResult<GetEmbedsRPC.Response, GetEmbedsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "report/GetEmbeds",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmbedsRPC.ResponseDTO,
      GetEmbedsRPC.Errors.ErrorsDTO,
      GetEmbedsRPC.Response,
      GetEmbedsRPC.Errors.Errors
    >(
      response,
      "report/GetEmbeds",
      GetEmbedsRPC.Response.fromDTO,
      GetEmbedsRPC.Errors.fromDTO
    );
  }
}
